import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from "react-dom/client";
import { createSurfaceCommands, posturesFor, Surface, switchPosture, } from "./layouts/index.js";
import { createSessionClient, } from "./session/client.js";
import { createSurfaceStore } from "./session/store.js";
/** Sources for a shell that has none yet: every lookup finds nothing. */
export const NO_SOURCES = Object.freeze({
    procedure: () => Promise.resolve(null),
    fieldLabel: () => Promise.resolve(null),
    persona: () => Promise.resolve(null),
    titles: () => Promise.resolve([]),
    mediaUrl: () => Promise.reject(new Error("no media source")),
    exportRecord: () => Promise.reject(new Error("no record source")),
});
export function mountSurface(el, options) {
    const { bridge } = options;
    const shell = bridge.shell;
    const offered = posturesFor(shell);
    const posture = options.posture ?? (offered.includes("companion") ? "companion" : (offered[0] ?? "orb"));
    const store = createSurfaceStore({
        posture,
        capabilities: options.capabilities ?? {
            voice: false,
            pointing: false,
            navigate: bridge.host.navigate !== undefined,
        },
        ...(options.onSpeech ? { onSpeech: options.onSpeech } : {}),
    });
    const client = createSessionClient({
        bridge,
        transport: options.session,
        store,
        ...(options.viewId === undefined ? {} : { viewId: options.viewId }),
        ...(options.practice === undefined ? {} : { practice: options.practice }),
        ...(options.timers === undefined ? {} : { timers: options.timers }),
        ...(options.ids === undefined ? {} : { ids: options.ids }),
        ...(options.voice === undefined ? {} : { voice: options.voice }),
    });
    const { actions } = client;
    const commands = createSurfaceCommands(store, actions, shell);
    const root = createRoot(el);
    root.render(_jsx(Surface, { store: store, actions: actions, sources: options.sources ?? NO_SOURCES, shell: shell, ...(options.perceives === undefined ? {} : { perceives: options.perceives }), ...(options.stage === undefined ? {} : { stage: options.stage }) }));
    let mounted = true;
    return {
        store,
        viewId: client.viewId,
        commands,
        setPosture(to) {
            switchPosture(store, actions, to);
        },
        unmount() {
            if (!mounted)
                return;
            mounted = false;
            root.unmount();
            client.close();
        },
    };
}
//# sourceMappingURL=mount.js.map